import { render, staticRenderFns } from "./EmailQueue.vue?vue&type=template&id=758bd670&"
import script from "./EmailQueue.vue?vue&type=script&lang=js&"
export * from "./EmailQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports